import { format, parse } from "date-fns";

const DATE_FORMAT = "dd/MM/yyyy";

export class DateUtils {

	static formatDateToBrazilFormat(valor: number): string {
		const data = new Date(valor);
		return format(data, DATE_FORMAT);
	}

	static formatDateBrazilFormat(date: Date | null): string {
		if(date){
			const data = new Date(date);
			return format(data, DATE_FORMAT);
		}
		return "";
	}

	static formatDateBrazilHorasormat(date: Date | null): string {
		if(date){
			const data = new Date(date);
			return format(data, "dd'/'MM'/'yyyy' - 'HH:mm");
		}
		return "";
	}

	static formatarDataAtualSemBarras(): string {
		return format(new Date(), "ddMMyyyy");
	}

	static formateDateService(valor: string): Date | null {
		if (valor) {
			const data = valor.split("-");
			return new Date(`${data[1]} ${data[0]} ${data[2]}`);
		} else {
			return null;
		}
	}

	/**@name datetimeToDate
	 * @description converte uma string com datetime pattern em date only
	 * @param date(string) datetime format
	 */
	static datetimeToDate(date: string): string {
		const onlyDate = date.split(" ");
		return onlyDate[0];
	}


	static isValidDate(dateString): boolean {
		const regex = /^\d{4}-\d{2}-\d{2}$/;
		if (!regex.test(dateString)) return false;
		const date = new Date(dateString);
		return date instanceof Date && !isNaN(date.getTime());
	}

	static isDateAfterToday(dateString): boolean {

		const [day, month, year] = dateString.split('/');
		const selectedDate = new Date(year, month - 1, day);

		const today = new Date();
		return selectedDate > today;
	}





	static converterStringParaData(dataString): Date | undefined {
		const data =  parse(dataString, DATE_FORMAT, new Date());
		if (isNaN(data.getTime())) {
			return undefined; // Retorna null se a data não for válida
		}
		return data;
	}	
}
